<div class="map-container">
  <div #mapContainer class="map-canvas"></div>
  @if (duration) {
    <div class="info-panel">
      <p>Tiempo estimado de entrega: {{ adjustedDuration }}</p>
      @if (trafficDensity) {
        <p class="traffic-info">
          Tráfico: {{ getTrafficDescription() }}
        </p>
      }
    </div>
  }
</div>
